import * as actions from './actions';

export type State = {
  tempScenario: Record<string, any>;
  modelledScenario: Record<string, any>;
  originalContributions: Record<string, any>;
};

export default (
  state: State = {
    tempScenario: {},
    modelledScenario: {},
    originalContributions: {},
  },
  action: any = {},
): State => {
  switch (action.type) {
    case actions.SET_INITIAL_STATE_FOR_CONTRIBUTIONS:
      return {
        ...state,
        tempScenario: {
          ...action.payload,
        },
        modelledScenario: {
          ...action.payload,
        },
        originalContributions: {
          ...action.payload,
        },
      };
    case actions.UPDATE_CONTRIBUTION_DATA:
      return {
        ...state,
        tempScenario: {
          ...state.tempScenario,
          ...action.payload,
        },
      };
    case actions.MODEL_CONTRIBUTION_DATA:
      return {
        ...state,
        modelledScenario: {
          ...state.tempScenario,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
